export default "__VITE_ASSET__99e75dad__$_?component__"